/* Bolletje naar de winkelwagen (23-10-2026), zelfde effect als op bedrukkingresellers.nl.
   Het toevoegen zelf doet flux-style-transfer.js / meshy-3d.js (AJAX + drawer); die sturen daarna
   'cart:added' of 'cart:updated'. Dit script onthoudt op welke toevoegknop geklikt is en laat bij dat
   event een rondje met de productfoto van die knop naar het winkelwagenicoon vliegen. */
(function () {
  if (window.bkVlieg) return;
  window.bkVlieg = true;

  var KNOP = 'button[name="add"], button.add-to-cart-button, button.bkp-cart-btn, [data-quick-add], ' +
    '.flux-st__add-cart-btn, form[action*="/cart/add"] button[type="submit"]';
  var laatste = null;   // { knop, foto, op }

  var stijl = document.createElement('style');
  stijl.textContent =
    '.bk-fly{position:fixed;width:54px;height:54px;border-radius:50%;background:#E89B2E center/cover no-repeat;' +
    'box-shadow:0 6px 18px rgba(0,0,0,.25);z-index:2147483647;pointer-events:none;' +
    'transition:transform .7s cubic-bezier(.22,.61,.36,1),opacity .7s ease}' +
    '.bk-pop{animation:bkPop .35s ease}@keyframes bkPop{0%{transform:scale(1)}50%{transform:scale(1.35)}100%{transform:scale(1)}}';
  document.head.appendChild(stijl);

  function zichtbaar(img) {
    var r = img.getBoundingClientRect();
    return r.width >= 60 && r.height >= 60 && r.bottom > 0 && r.top < innerHeight;
  }
  // productfoto bij de knop: eerst de vaste plekken, anders de grootste zichtbare foto in een omliggend blok
  function fotoBij(knop) {
    var vast = document.querySelector('.bkp-gallery-main img');
    if (vast && knop.closest('.bkp-form') && zichtbaar(vast)) return vast;
    var el = knop;
    for (var i = 0; i < 6 && el; i++) {
      el = el.parentElement;
      if (!el) break;
      var beste = null, opp = 0;
      el.querySelectorAll('img').forEach(function (img) {
        if (!zichtbaar(img)) return;
        var r = img.getBoundingClientRect();
        if (r.width * r.height > opp) { opp = r.width * r.height; beste = img; }
      });
      if (beste) return beste;
    }
    return null;
  }
  function icoon() {
    var kandidaten = document.querySelectorAll('.header-actions__cart-icon, cart-icon, header a[href$="/cart"], header [aria-controls*="cart"], a[href="/cart"]');
    for (var i = 0; i < kandidaten.length; i++) {
      var r = kandidaten[i].getBoundingClientRect();
      if (r.width && r.height) return kandidaten[i];
    }
    return null;
  }

  function vlieg(bron, foto) {
    var doel = icoon();
    if (!doel || !bron) return;
    var s = (foto || bron).getBoundingClientRect(), t = doel.getBoundingClientRect();
    var bol = document.createElement('div');
    bol.className = 'bk-fly';
    if (foto) bol.style.backgroundImage = 'url("' + (foto.currentSrc || foto.src) + '")';
    bol.style.left = (s.left + s.width / 2 - 27) + 'px';
    bol.style.top = (s.top + s.height / 2 - 27) + 'px';
    document.body.appendChild(bol);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        bol.style.transform = 'translate(' + ((t.left + t.width / 2) - (s.left + s.width / 2)) + 'px,' +
          ((t.top + t.height / 2) - (s.top + s.height / 2)) + 'px) scale(.15)';
        bol.style.opacity = '.3';
      });
    });
    setTimeout(function () {
      bol.remove();
      var bel = document.querySelector('.header-actions__cart-icon .cart-bubble') || doel;
      bel.classList.add('bk-pop');
      setTimeout(function () { bel.classList.remove('bk-pop'); }, 360);
    }, 720);
  }

  // capture: vóór de toevoeg-code, die de klik stopt
  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest(KNOP);
    if (!knop || knop.closest('cart-drawer-component, [class*="cart-drawer"], cart-items-component')) return;
    laatste = { knop: knop, foto: fotoBij(knop), op: Date.now() };
  }, true);

  function toegevoegd() {
    // alleen na een echte toevoegklik (ontwerptools mogen eerst hun ontwerp uploaden)
    if (!laatste || Date.now() - laatste.op > 60000) return;
    var l = laatste; laatste = null;
    vlieg(l.knop, l.foto && l.foto.isConnected ? l.foto : null);
  }
  document.addEventListener('cart:added', toegevoegd);
  document.addEventListener('cart:updated', toegevoegd);
})();
